import { render, staticRenderFns } from "./ContactListView.vue?vue&type=template&id=1f125638&"
import script from "./ContactListView.vue?vue&type=script&lang=js&"
export * from "./ContactListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports